<div class="activity-tabs align-items-end border-bottom px-2">
    <div class="tab-item" *ngFor="let tab of tabs"
         [ngClass]="{'restrict-pointer': callRestrictValue }"
         [class.active]="selectedTab === tab.id"
         (click)="selectTab(tab.id)">
        {{ tab.labelKey | translate }}
        <span [tooltip]="tab.tooltipKey | translate" placement="bottom" container="body" [adaptivePosition]="false" class="activity-badbge">{{ getTabCount(tab.id) }}</span>
    </div>
    <div class="ml-auto open-list-link">
        <a href="/scheduled_activities" (click)="onListScreenClicks()">Open activity in list</a>
    </div>
</div>

<div class="ml-1 left-side-space">
    <div class="search-container" >
        <div class="search-input-wrapper">
            <div class="search-bar">
                <div class="search-icon-wrapper">
                    <i class="fa fa-search search-icon"></i>
                </div>
                <div class="left-spacing"></div>
                <ng-container *ngFor="let tag of selectedTagFilters">
                    <span class="selected-user">
                        <span class="user-profile-name">#{{ tag.description }}</span>
                        <span class="remove-user" (click)="removeTagFilter(tag)"><i class="fa fa-times"></i></span>
                    </span>
                </ng-container>
                <input type="text"
                       class="search-input"
                       placeholder="Search"
                       [(ngModel)]="param.searchText"  (valueChanged)="onSearch()" (input)="onSearchInput($event)" appDebounceTimer/>
                <div class="clear-input-wrapper" *ngIf="param.searchText">
                    <i class="fa fa-times-circle clear-input" (click)="clearSearch()"></i>
                </div>
            </div>
            <ul class="dropdown-list" *ngIf="showTagDropdown">
                <li *ngFor="let tag of filteredTags" (click)="selectTagFilter(tag)">#{{ tag.description }}</li>
            </ul>
        </div>
    </div>
    <br />
    <div *ngIf="showUndoMessage" class="undo-message">
        Was that a mistake? Click <a href="javascript:void(0)" (click)="undoCompleted()">Undo</a> <span class="close-undo" (click)="showUndoMessage = false"><i class="fa fa-close"></i></span>
    </div>

    <!-- Single loop for both tabs -->
    <div class="activities-scroll-wrapper">
        <div #activitiesScroll class="activities-scroll" [class.scroll-hidden]="loading || isLoadingMore" (scroll)="onScroll($event)" (touchend)="onTouchEnd()">
            <div *ngIf="!loading">
                <ng-container *ngIf="activities.length > 0; else noRecords">
                    <ng-container *ngFor="let activity of activities">
                        <div class="activity-card">
                            <div class="activity-header">
                                <input type="checkbox" class="input-align" (change)='onRowSelect(activity, $event)' [disabled]="activity.isSelected" />
                                <span class="badge badge-secondary">
                        <i class="fa fa-phone icon-right-space" *ngIf="activity.activityType == 'Call'"></i>
                        <i class="fa fa-envelope icon-right-space" *ngIf="activity.activityType == 'Email'"></i>
                        <svg class="icon-right-space meeting-icon" *ngIf="activity.activityType == 'Meeting'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M3.0625 5.75C3.0625 5.02065 3.35223 4.32118 3.86796 3.80546C4.38368 3.28973 5.08315 3 5.8125 3C6.54185 3 7.24132 3.28973 7.75704 3.80546C8.27277 4.32118 8.5625 5.02065 8.5625 5.75C8.5625 6.47935 8.27277 7.17882 7.75704 7.69454C7.24132 8.21027 6.54185 8.5 5.8125 8.5C5.08315 8.5 4.38368 8.21027 3.86796 7.69454C3.35223 7.17882 3.0625 6.47935 3.0625 5.75ZM1 13.3619C1 11.2457 2.71445 9.53125 4.83066 9.53125H6.79434C8.91055 9.53125 10.625 11.2457 10.625 13.3619C10.625 13.7143 10.3393 14 9.98691 14H1.63809C1.28574 14 1 13.7143 1 13.3619ZM14.0904 14H11.1277C11.2437 13.798 11.3125 13.5639 11.3125 13.3125V13.1406C11.3125 11.8365 10.7303 10.6656 9.81289 9.8793C9.86445 9.87715 9.91387 9.875 9.96543 9.875H11.2846C13.1988 9.875 14.75 11.4262 14.75 13.3404C14.75 13.7057 14.4535 14 14.0904 14ZM10.2812 8.5C9.61523 8.5 9.01367 8.2293 8.57754 7.79316C9.00078 7.22168 9.25 6.51484 9.25 5.75C9.25 5.17422 9.1082 4.63066 8.85684 4.15371C9.25645 3.86152 9.74844 3.6875 10.2812 3.6875C11.6111 3.6875 12.6875 4.76387 12.6875 6.09375C12.6875 7.42363 11.6111 8.5 10.2812 8.5Z" fill="white"/>
</svg>
                        <i class="fa-regular fa-list-check icon-right-space" *ngIf="activity.activityType == 'Task'"></i>
                                    {{ activity.activityType }}</span>
                                <div class="" *ngIf="activity?.assignees && activity?.assignees?.length">
                                    <app-user-icon-list [usersList]="activity?.assignees?.length"
                                                        [imageList]="activity?.assignees"></app-user-icon-list>
                                </div>
                                <div class="activity-users align-user" [ngClass]="{'space-activity-users': activity?.assignees && activity?.assignees?.length ,'reduce-space-left' : selectedTab === 'unassignedActivity'}" *ngIf="(usersWritePermission || usersUpdatePermission) && activity?.teamMembersConfig">
                                    <app-cs-drop-down
                                        [ddConfig]="activity?.teamMembersConfig"
                                        (ddItemClick)="selectedTeamMember($event,activity)">
                                    </app-cs-drop-down>
                                </div>
                                <div class="current-users assign-job-pointer">
                                    <a [style.display]="activity?.isAssignJobToLoggedInUser ? 'block' : 'none'"
                                       *ngIf="activity?.isAssignJobToLoggedInUser"
                                       (click)="takeThisJob(activity);" style="text-wrap: nowrap;">Take this activity</a>
                                </div>
                                <div class="due-date-container">
                                    <span class="" [ngClass]="ModifyActivityDate(activity.timeToShow).label == 'Overdue'? 'overdue-mode' : 'future-mode'" [tooltip]="ModifyActivityDate(activity.timeToShow).tooltip" [placement]="'bottom'">{{ ModifyActivityDate(activity.timeToShow).label }}</span>
                                </div>
                            </div>
                            <div class="ml-1 mr-1 left-side-space card-box-color">
                                <h5 class="title heading-size">{{ activity.description }}</h5>
                                <p class="note">{{ activity.notes }}</p>

                                <div class="meta">
                                    <div *ngIf="activity.recordType == 'job'"><i class="fa fa-briefcase w-h-16"></i> <a target="_blank"  href="/customers/{{customerType}}/{{activity.jobParentID }}/jobs_v2/{{activity.recordId }}/details/view">{{ activity.recordId }} <span class="fa fa-external-link" style="color: #CCCCCC"></span></a></div>
                                    <div *ngIf="activity.recordType == 'Opportunity'"><i class="fa-solid fa-badge-dollar w-h-16"></i> <a target="_blank"  href="/customers/{{customerType}}/{{activity?.customerDetails?.customerId }}/opportunity/{{activity.recordId }}/view">{{ activity.recordId }} <span class="fa fa-external-link" style="color: #CCCCCC"></span></a></div>
                                    <div *ngIf="activity.recordType == 'contract'"><i class="fa fa-briefcase w-h-16"></i> <a target="_blank"  href="/customers/{{customerType}}/{{activity?.customerDetails?.customerId }}/customer_contracts/{{activity.recordId }}/view/timeline">{{ activity.recordId }} <span class="fa fa-external-link" style="color: #CCCCCC"></span></a></div>
                                    <div><i class="fa fa-user icon-user-space w-h-16"></i> <a target="_blank"  href="/customers/customer/{{activity?.customerDetails?.customerId}}/view_v2/communications/view">{{ activity?.customerDetails?.customerName }} <span class="fa fa-external-link" style="color: #CCCCCC"></span></a></div>
                                    <div class="address-align"><i class="fa fa-home icon-padding w-h-16"></i> {{ activity?.siteContactDetails?.siteContactAddress }}</div>
                                </div>
                                <app-activity-add-tag (tagSelected)="onTagSelected($event, activity)" (tagRemoved)="onTagRemoved($event, activity)" [selectedTagsList]="activity.tagsList"
                                                      [activity]="activity"></app-activity-add-tag>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
                <ng-template #noRecords>
                    <div class="no-records-found">
                        <div class="icon">
                            <i class="fa-solid fa-circle-info"></i>
                        </div>
                        <div class="text">
                            No records found
                        </div>
                    </div>
                </ng-template>
            </div>
            <ng-container *ngIf="loading">

                <ul class="initial-loader-list margin-left-class" *ngFor="let i of [1,2,3,4,5,6]">
                    <div class="loader-class">
                        <div class="text-layout animated-background w-33 left-auto slide-is-2 margin-top-class loader-height" ></div>
                        <div class="text-layout animated-background w-25 left-auto slide-is-2 margin-top-class loader-height" ></div>
                    </div>
                    <div class="line-1 loader-style-one">
                        <div class="text-layout animated-background w-50 left-auto slide-is-2 margin-top-class" ></div>
                        <div class="text-layout animated-background w-100 left-auto slide-is-2 margin-top-class" ></div>
                    </div>
                    <div class="line-1">
                        <div class="text-layout animated-background w-80 left-auto slide-is-2 margin-top-class" ></div>
                        <div class="text-layout animated-background w-60 left-auto slide-is-2 margin-top-class" ></div>
                        <div class="text-layout animated-background w-60 left-auto slide-is-2 margin-top-class" ></div>
                        <div class="text-layout animated-background w-60 left-auto slide-is-2 margin-top-class" ></div>
                    </div>
                </ul>
            </ng-container>
        </div>
        <div class="close-btn-container">
            <button class="close-btn" (click)="onCloseModal()">Close</button>
        </div>
    </div>
</div>
<ng-template #dropDownCustomRender let-data="togglerConfig" let-menuData="menuConfig">
    <a class="custom-render-drop-down" [style.background]="data['templateData']?.background" [ngClass]="{'with-background': data['templateData']['background']}">
        <span translate *ngIf="data['templateData']['text']; else unassigned">{{data['templateData']['text']}}</span>
        <ng-template #unassigned><span>Unassigned</span></ng-template>
        <span class="text dropdown-list-icons"><i class="fa fa-chevron-down" aria-hidden="true"></i></span>
    </a>
</ng-template>
<ng-template #dropDownCustomRenderCheckbox let-data="togglerConfig" let-menuData="menuConfig">
    <div id="job-menu-button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <span class="add-user-container">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M3.1 4.8C3.1 4.05739 3.395 3.3452 3.9201 2.8201C4.4452 2.295 5.15739 2 5.9 2C6.64261 2 7.3548 2.295 7.8799 2.8201C8.405 3.3452 8.7 4.05739 8.7 4.8C8.7 5.54261 8.405 6.2548 7.8799 6.7799C7.3548 7.305 6.64261 7.6 5.9 7.6C5.15739 7.6 4.4452 7.305 3.9201 6.7799C3.395 6.2548 3.1 5.54261 3.1 4.8ZM1 12.5503C1 10.3956 2.74563 8.65 4.90031 8.65H6.89969C9.05437 8.65 10.8 10.3956 10.8 12.5503C10.8 12.9091 10.5091 13.2 10.1503 13.2H1.64969C1.29094 13.2 1 12.9091 1 12.5503ZM12.025 8.825V7.425H10.625C10.3341 7.425 10.1 7.19094 10.1 6.9C10.1 6.60906 10.3341 6.375 10.625 6.375H12.025V4.975C12.025 4.68406 12.2591 4.45 12.55 4.45C12.8409 4.45 13.075 4.68406 13.075 4.975V6.375H14.475C14.7659 6.375 15 6.60906 15 6.9C15 7.19094 14.7659 7.425 14.475 7.425H13.075V8.825C13.075 9.11594 12.8409 9.35 12.55 9.35C12.2591 9.35 12.025 9.11594 12.025 8.825Z" fill="#505B65"/>
            </svg>
        </span>
    </div>
</ng-template>

<div #callLogWrapper *ngIf="selectedWidgetsType == 'call' && showCallLogModal">
    <app-call-log-modal [showCallLogModal]="showCallLogModal"
                        [isCommonRoute]="isCommonRoute"
                        [opportunityId]="opportunityId"
                        [customerId]="customerId"
                        [editCallData]="callEditData"
                        [activityList]="activityList"
                        (onClose)="onModalClose('call')"
                        [customerType]="customerType"
                        [screenType]="screenType"
                        (onSave)="onCallLogSave($event)"
                        [scheduled]="scheduled"
                        [usersList]="usersList">
    </app-call-log-modal>
</div>
<div #oppCallLogWrapper *ngIf="selectedWidgetsType == 'call' && showOpportunityCallLogModal">
    <app-cs-call-log-modal [showCallLogModal]="showOpportunityCallLogModal"
                           [opportunityId]="opportunityId"
                           [customerId]="customerId"
                           [editCallData]="callEditData"
                           [completedActivityData]="selectedActivity"
                           [activityList]="activityList"
                           (onClose)="onModalClose('call')"
                           (onSave)="onCallLogSave($event)"
                           [screen]="'scheduledActivities'" [usersList]="assigneeList"
                           [showCallCustomFields]="true" [showCallNoteTemplateOption]="true">
    </app-cs-call-log-modal>
</div>
